import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgKazakhstan = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-kazakhstan';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 18",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#Kazakhstan_svg__a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#03BCDB",
        d: "M0 0h24v18H0z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FFDA2C",
        d: "M13.257 10.8c1.578 0 2.857-1.343 2.857-3s-1.279-3-2.857-3-2.857 1.343-2.857 3 1.279 3 2.857 3"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FFDA2C",
        fillRule: "evenodd",
        d: "m9.257 8.4 1.143 2.4 2.857 1.2 2.857-1.2 1.143-2.4V12l-4 1.2-4-1.2zM2.4 2.994A.59.59 0 0 1 2.97 2.4c.316 0 .572.26.572.594v2.412A.59.59 0 0 1 2.97 6a.58.58 0 0 1-.571-.594zm1.143 2.4a.59.59 0 0 1 .571-.594c.316 0 .572.26.572.594v2.412a.59.59 0 0 1-.572.594.58.58 0 0 1-.571-.594zm0 4.8a.59.59 0 0 1 .571-.594c.316 0 .572.26.572.594v2.412a.59.59 0 0 1-.572.594.58.58 0 0 1-.571-.594zm-1.143 2.4A.59.59 0 0 1 2.97 12c.316 0 .572.26.572.594v2.412a.59.59 0 0 1-.572.594.58.58 0 0 1-.571-.594zm0-4.794c0-.331.265-.6.571-.6.316 0 .572.278.572.6 0 .331-.265.6-.572.6-.315 0-.571-.279-.571-.6M3.543 3c0-.331.265-.6.571-.6.316 0 .572.278.572.6 0 .331-.266.6-.572.6-.315 0-.571-.279-.571-.6M2.4 9c0-.331.265-.6.571-.6.316 0 .572.278.572.6 0 .331-.265.6-.572.6-.315 0-.571-.278-.571-.6m1.143 6c0-.331.265-.6.571-.6.316 0 .572.278.572.6 0 .331-.266.6-.572.6-.315 0-.571-.278-.571-.6M2.4 10.2c0-.331.265-.6.571-.6.316 0 .572.278.572.6 0 .331-.265.6-.572.6-.315 0-.571-.279-.571-.6",
        clipRule: "evenodd"
      })]
    }), /*#__PURE__*/_jsx("rect", {
      width: 23.5,
      height: 17.5,
      x: 0.25,
      y: 0.25,
      stroke: "#DFE2EC",
      strokeWidth: 0.5,
      rx: 1.75,
      style: {
        fillOpacity: 0
      }
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "Kazakhstan_svg__a",
        children: /*#__PURE__*/_jsx("rect", {
          width: 24,
          height: 18,
          fill: "#fff",
          rx: 2
        })
      })
    })]
  }));
});
export default SvgKazakhstan;